import get from 'lodash/get';
import identity from 'lodash/identity';
import { createSelector } from 'reselect';
import { hasPermission } from 'utils/permissions';

function groupWithValidItems(group, permissions) {
  const items = group.items
    .filter(identity)
    .filter(({ permission }) =>
      typeof permission === 'function'
        ? permission(permissions)
        : !permission || hasPermission(permissions, permission),
    );

  return { ...group, items };
}

export const pruneItemsAndGroups = (groupedItems, permissions) =>
  groupedItems
    .filter(identity)
    .map(group => groupWithValidItems(group, permissions))
    .filter(({ items }) => items.length);

export const selectFeatureToggleMap = ({ featureToggles }) =>
  get(featureToggles, 'featureToggleMap', {});
export const selectLoggedInUser = ({ loggedInUser }) => loggedInUser;
export const selectPermissions = ({ loggedInUser }) =>
  loggedInUser.loggedInUserProfile.permissions;
export const selectSubMenuId = ({ navigation }) => navigation.subMenuId;

export const getHasPermissionSelector = requiredPermission =>
  createSelector([selectPermissions], permissions =>
    hasPermission(permissions, requiredPermission),
  );
